import { Controller } from "@hotwired/stimulus"
import { SearchButton } from "@coreui/coreui-pro"

// Pagila e09e99e introduces SearchButton; keep Cybros' existing report index.
export default class extends Controller {
  connect() {
    this.searchButton = SearchButton.getOrCreateInstance(this.element)
  }

  open() {
    const palette = document.querySelector("ninja-keys")
    if (!palette) return

    if (palette.visible) {
      palette.close()
    } else {
      palette.open()
    }
    // Ninja renders in a shadow root. Restore keyboard focus after Escape,
    // the shortcut or a backdrop click closes its existing palette.
    this.observer?.disconnect()
    const modal = palette.shadowRoot?.querySelector(".modal")
    if (!modal) return

    this.observer = new MutationObserver(() => {
      if (palette.visible) return

      this.observer.disconnect()
      if (this.element.isConnected) this.element.focus()
    })
    this.observer.observe(modal, { attributes: true, attributeFilter: ["class"] })
  }

  unmount() {
    this.observer?.disconnect()
    this.searchButton?.dispose()
    this.searchButton = null
  }

  disconnect() {
    this.unmount()
  }
}
